// extracted by mini-css-extract-plugin
export default {"ellipsis":"styles_ellipsis__6ZLsl","breakWord":"styles_breakWord__kM3VS"};